import { Table } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { InteractionRequiredAuthError, InteractionStatus } from '@azure/msal-browser';
import { protectedResources } from '../../authConfig';
import { jwtDecode } from "jwt-decode";
import { createClaimsTable } from '../../utils/claimUtils';

export const AccessTokenData = () => {

    const { instance, inProgress, accounts } = useMsal();
    //const [apiData, setApiData] = useState(null);
    const [accessToken, setAccessToken] = useState(null);

    const tableRows = accessToken ? Object.entries(createClaimsTable(accessToken)).map((item, index) => {
        const displayItem = item[1];
        const claimType = displayItem[0];
        const rawValue = displayItem[1];

        let renderedValue;
        if (claimType === 'scp' && typeof rawValue === 'string') {
            renderedValue = rawValue.split(' ').join(", ");
        } else if (Array.isArray(rawValue)) {
            renderedValue = rawValue.join(', ');
        } else if (rawValue && typeof rawValue === 'object') {
            renderedValue = JSON.stringify(rawValue);
        } else {
            renderedValue = rawValue;
        }

        return (
            <tr key={claimType}>
                <td>{claimType}</td>
                <td>{renderedValue}</td>
                {/* <td key={displayItem[2]}>{displayItem[2]}</td> */}
            </tr>
        );
    }) : null;

    useEffect(() => {

        const accessTokenRequest = {
            scopes: [ // These are the things the user might want to do/access. They can request literally anything... but the IdP will only return what they actually have.
                ...protectedResources.apiCalendar.scopes.read,
                ...protectedResources.apiCalendar.scopes.write,
                ...protectedResources.apiKanBan.scopes.read,
                ...protectedResources.apiKanBan.scopes.write
            ],
            account: accounts[0],
        };

        if (/*!apiData &&*/ !accessToken && inProgress === InteractionStatus.None) {

            instance
                .acquireTokenSilent(accessTokenRequest)
                .then((accessTokenResponse) => {
                    // Acquire token silent success
                    let token = jwtDecode(accessTokenResponse.accessToken);
                    setAccessToken(token);
                    console.log(token);
                    // Call your API with token
                    // callApi(accessToken).then((response) => {
                    //     setApiData(response);
                    // });
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        // Let higher-level auth gate handle interactive login
                    }
                    console.log(error);
                });
        }
    }, [instance, accounts, inProgress, /*apiData,*/ accessToken]);


    return (
        <>
            <div className="data-area-div">
                <p>
                    See below the claims in your <strong> Access token </strong>.
                </p>
                <div className="data-area-div">
                    <Table responsive striped bordered hover>
                        <thead>
                            <tr>
                                <th>Claim</th>
                                <th>Value</th>
                            </tr>
                        </thead>
                        <tbody>{tableRows}</tbody>
                    </Table>
                </div>
            </div>
        </>
    );
};
